import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EssayWritingTemplate from 'templates/EssayWriting';
import BottomBar from '../../../components/organisms/essayWriting/BottomBar';
import EditorSection from '../../../components/organisms/essayWriting/EditorSection';
import PerformanceContext from '../PerformanceMain/context';
import SwitchPerformanceContext from '../SwitchPage/context';
import {
  EditorType,
  WritingEssayStageObjectType,
} from '../../../apis/performances';
import QuillEditorEssayWriting from '../QuillEditorEssayWriting';

const EssayWriting: React.FC = () => {
  const { setPageTitle } = useContext(PerformanceContext);
  const { stage_object } = useContext(SwitchPerformanceContext);
  const { t } = useTranslation();
  const assertedStageObject = stage_object as WritingEssayStageObjectType;
  useEffect(() => {
    setPageTitle(t('app.에세이작성'));
  }, [setPageTitle, t]);

  const isQuill =
    assertedStageObject.editor_type === EditorType.QUILL ||
    !assertedStageObject.content;

  return isQuill ? (
    <QuillEditorEssayWriting />
  ) : (
    <EssayWritingTemplate BottomBar={BottomBar} EditorSection={EditorSection} />
  );
};

export default React.memo(EssayWriting);
